import { css, cx } from '@emotion/css';
import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { useInterval } from '../custom-hooks/custom-hooks';
import { Colors } from '../styles/colors';
import { doctrineStencilStyle, tabularNumbersStyle } from '../styles/text';
import { getDurationFormat } from '../utils/duration';
import { Radius } from '../styles/tokens';

type DurationTimerProps = {
  startTime: Date;
};

export const DurationTimer = (props: DurationTimerProps): JSX.Element => {
  const { startTime } = props;

  const diff = dayjs().diff(dayjs(startTime));
  const durr = dayjs.duration(diff);

  const durationFormat = useMemo(() => getDurationFormat(durr), [durr]);

  const [duration, setDuration] = useState<string>(durr.format(durationFormat));
  const [delay] = useState<number>(1000);

  useInterval(() => {
    const diff = dayjs().diff(dayjs(startTime));
    const durr = dayjs.duration(diff);
    setDuration(durr.format(durationFormat));
  }, delay);

  return (
    <div>
      <label>Duration</label>
      <div
        className={cx(doctrineStencilStyle, tabularNumbersStyle, timerStyle)}
        role="timer"
        aria-live="off"
      >
        {duration}
      </div>
    </div>
  );
};

const timerStyle = css`
  display: inline-block;
  min-width: 4rem;
  color: ${Colors.WHITE};
  background: ${Colors.CAPRI_BLUE};
  border-radius: ${Radius.md};
  padding: 0.25rem 0.75rem;
`;
